import { FormDateFieldProps } from '../FormDateField/FormDateField';
import {
  generateOptions,
  generateOptionsWithSameLabelAsValue,
} from './form-field-options-helpers';

export type PredefinedOptionsList =
  | 'day_options'
  | 'month_options'
  | 'year_options'
  | 'handicap_decimals_options'
  | 'handicap_category_options'
  | 'undefined';

export const formFieldOptionsList: Record<
  PredefinedOptionsList,
  (...args: any[]) => any
> = {
  day_options: () => {
    return generateOptions(1, 31);
  },
  month_options: () => {
    const monthOptions = generateOptions(1, 12, index =>
      new Date(0, index - 1).toLocaleString('en-US', { month: 'long' }),
    );
    return monthOptions;
  },
  year_options: (props?: FormDateFieldProps) => {
    const currentYear = new Date().getFullYear();
    const yearOffset = props?.yearOffset ?? 0;
    const maximumYear = currentYear - yearOffset;
    const yearOptions = generateOptions(
      props?.minimumYear ?? 1900,
      maximumYear,
    ).reverse();
    return yearOptions;
  },
  handicap_decimals_options: () => {
    return generateOptionsWithSameLabelAsValue(0, 9, index => `.${index}`);
  },
  handicap_category_options: () => {
    const options = [];

    for (let i = 0; i <= 4; i++) {
      const value = (i / 10).toFixed(1);
      options.push({ label: value, value });
    }

    for (let i = 0; i <= 99; i++) {
      const value = `+${(i / 10).toFixed(1)}`;
      options.push({ label: value, value });
    }

    return options;
  },
  undefined: () => [],
};
